import request from '@/utils/httpRequest'

export function getNewliveList (query, menuId) {
  return request({
    url: `/api/culture/newLive/web/${menuId}/list`,
    method: 'get',
    params: query
  })
}
export function getNewliveDetail (id) {
  return request({
    url: `/api/culture/newLive/web/${id}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/newlive/index.js